import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  Spacer,
  Layout,
  Col,
  Hide,
} from 'athenaeum';

import BlogIntro from '../Intro/Blog';
import ArticleImage from '../ArticleImage';
import MobileBack from '../MobileBack';
import { fetchPosts } from '../../utils/fetchMagazinePosts';
import fullBlogUrl from '../../utils/fullBlogUrl';

import styles from '../ProductDisplay/product_display.module.scss';

class MagazineDisplay extends Component {
  constructor() {
    super();

    this.state = {
      'latest-magazine': {
        loading: true,
        data: [],
      },
      'money-magazine': {
        loading: true,
        data: [],
      },
      'tech-magazine': {
        loading: true,
        data: [],
      },
      'how-tos-magazine': {
        loading: true,
        data: [],
      },
      'interviews-magazine': {
        loading: true,
        data: [],
      },
      'news-magazine': {
        loading: true,
        data: [],
      },
    };
  }

  componentWillReceiveProps(nextProps) {
    const emptyPosts = this.state[this.props.activeName].data.length === 0;

    if (nextProps.isActive && emptyPosts) {
      fetchPosts({
        featured: 'true',
        tag: this.props.tag,
        limit: 3,
      }).then((data) => {
        this.setState({
          [this.props.activeName]: {
            loading: false,
            data: data.posts,
          }
        });
      });
    }
  }

  get list() {
    const {
      activeName,
      mobileCollapsedMenu,
    } = this.props;

    const { data } = this.state[activeName];

    return data.map(post => (
      <Col
        key={post.url}
        fullwidth={mobileCollapsedMenu}
      >
        <ArticleImage
          header={post.title}
          imgProps={{
            src: `${post.feature_image}?fit=crop&w=640&h=360`,
          }}
          link={fullBlogUrl(post.url)}
        />
      </Col>
    ));
  }

  render() {
    const {
      headerText,
      description,
      setMobileCollapsedMenu,
      intro,
      isActive,
      activeName,
      mobileCollapsedMenu,
      onClick,
    } = this.props;

    const displayClasses = classnames(
      styles['submenu-display'],
      isActive && styles['submenu-display-active'],
      mobileCollapsedMenu === activeName && styles['mobile-collapsed'],
    );

    return (
      <div
        className={displayClasses}
        onClick={e => onClick(e)}
      >
        <MobileBack
          setMobileCollapsedMenu={setMobileCollapsedMenu}
          text="Magazine"
        />

        <Spacer size={36} />

        <Layout
          fullwidth
          smallCols={[12]}
          largeCols={[4, 8]}
          className={styles.content}
        >
          <Col
            className={styles.intro}
          >
            <Hide hideOn="tablet desktop">
              <Spacer size={24} />
            </Hide>
            <Hide hideOn="mobile tablet">
              <Spacer size={36} />
              <Spacer size={12} />
            </Hide>

            <BlogIntro
              intro={intro}
              headerText={headerText}
              description={description}
            />

            <Hide hideOn="desktop">
              <Spacer size={36} />
            </Hide>
          </Col>

          <Col
            fullwidth
          >
            <Layout
              fullwidth
              smallCols={[12]}
              mediumCols={[4]}
            >
              { this.list }
            </Layout>
          </Col>
        </Layout>
        <Spacer size={36} />
        <Spacer size={12} />
      </div>
    );
  }
}

MagazineDisplay.propTypes = {
  isActive: PropTypes.bool,
  activeName: PropTypes.string,
  tag: PropTypes.string,
  headerText: PropTypes.string,
  description: PropTypes.string,
  setMobileCollapsedMenu: PropTypes.func,
  intro: PropTypes.object,
  mobileCollapsedMenu: PropTypes.string,
  onClick: PropTypes.func,
};

export default MagazineDisplay;



// WEBPACK FOOTER //
// ../src/templates/MainNav/Submenu/MagazineDisplay/index.js